import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DashboardService } from '@service';

/**
 * Dashboard resolver function (Angular 14+ functional API)
 * Replaces the deprecated class-based DashboardResolver
 */
export const dashboardResolver: ResolveFn<string[]> = () => {
  const dashboardService = inject(DashboardService);
  return dashboardService.fakeCall$();
};
